import { useState } from 'react';
/**
 * @fileoverview
 * This package safely returns the value at a requested path inside of
 * an object. Best used on unpredictable deeply nested structures. Supports
 * arrays as well. See README.md for more info.
 *
 */

/**
 * @param {Array.<string|number>|String} path – e.g ['key1', 0, 'key2'] or a string such as 'key1.0.key2
 * @param {Object|Array} object
 * @returns {*}
 */

var getNestedValue = function getNestedValue(path, object) {
  if (!Array.isArray(path) && typeof path !== 'string') {
    throw Error('The package get-nested-value received a non-contract path. Please provide a string, number, or an array of those!');
  }

  var searchPath = path;

  if (!Array.isArray(path)) {
    searchPath = searchPath.split('.');
  }

  return searchPath.reduce(function (prev, cur) {
    if (prev && prev[cur] !== undefined) {
      return prev[cur];
    }

    return undefined;
  }, object);
};

var readme = getNestedValue;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var useMap = function useMap() {
  var initialMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (process.env.NODE_ENV !== 'production' && ((typeof initialMap === 'undefined' ? 'undefined' : _typeof(initialMap)) !== 'object' || Array.isArray(initialMap))) {
    console.error('The useMap hook should be initialized with an object!');
  }

  var _useState = useState(initialMap),
      _useState2 = slicedToArray(_useState, 2),
      map = _useState2[0],
      _set = _useState2[1];

  return [map, {
    replace: _set,
    get: function get$$1(key) {
      return map[key];
    },
    getIn: function getIn(path) {
      return readme(path, map);
    },
    set: function set$$1(key, value) {
      return _set(function (m) {
        return _extends({}, m, defineProperty({}, key, value));
      });
    },
    update: function update(key, updateFn) {
      return _set(function (m) {
        return _extends({}, m, defineProperty({}, key, updateFn(m[key])));
      });
    },
    remove: function remove(key) {
      return _set(function (m) {
        delete m[key];
        return m;
      });
    }
  }];
};

export default useMap;